import { gql, useMutation } from '@apollo/client'
import cx from 'classnames'
import { useState } from 'react'
import { MarkKitObservedMutation, MarkKitObservedMutationVariables } from './__generated__/MarkKitObservedMutation'

export const markKitObservedMutation = gql`
  mutation MarkKitObservedMutation($input: MarkKitObservedInput!) {
    markKitObserved(input: $input) {
      success
    }
  }
`

const toFriendlySku = (sku: string) => {
  if (sku === 'rapid_travel') {
    return 'Healgen Rapid Test'
  }

  if (sku === 'rapid_travel_hughes') {
    return 'Hughes Rapid Test'
  }

  return sku
}

interface KitChecklistProps {
  kitId: string
  orderId: string
  videoSupervisionId: string
  sku: string
  onComplete: () => void
}

const KitChecklist = ({ kitId, orderId, videoSupervisionId, sku, onComplete }: KitChecklistProps) => {
  const [idChecked, setIdChecked] = useState(false)

  const [markKitObserved, { loading, data }] = useMutation<MarkKitObservedMutation, MarkKitObservedMutationVariables>(
    markKitObservedMutation,
    {
      variables: { input: { kitId, orderId, videoSupervisionId } },
      onCompleted: () => onComplete(),
    }
  )

  const isObserved = data?.markKitObserved.success

  return (
    <>
      <td>
        <a href={`/dashboard/kit/${kitId}`} target="_blank">
          {kitId}
        </a>
      </td>
      <td>{toFriendlySku(sku)}</td>
      <td>
        <button
          className="button is-small is-outlined is-info"
          onClick={() => setIdChecked(true)}
          disabled={isObserved}
        >
          <span
            className={cx('mr-1', {
              'is-invisible': !idChecked,
            })}
          >
            &#10003;
          </span>
          ID OK
        </button>
      </td>
      <td>
        <button
          className={cx('button is-small is-primary ml-2', {
            'is-loading': loading,
          })}
          disabled={!idChecked || isObserved}
          onClick={() => markKitObserved()}
        >
          <span
            className={cx('mr-1', {
              'is-invisible': !isObserved,
            })}
          >
            &#10003;
          </span>
          Test observed
        </button>
      </td>
    </>
  )
}

export default KitChecklist
